module.exports = __webpack_public_path__ + "img/star-solid.9439e45c.svg";